<div class="wrapper-modal report">
    <div class="wrapper-modal-content">
        <div class="header-modal-report">
            <span>{{'LIST_SINGLE_PAGE.report' | translate}}</span>
            <button (click)="closeModal.emit()" class="custom-btn custom-btn--circle-outline">
                <img src="../../../assets/icons/outline/icon-close-modal.svg" alt="">
            </button>
        </div>
        <div class="content-modal-report">
            <span class="modal-title">{{'NEW_TEXT.why_are_you_reporting_this_post' | translate}}?</span>
            <span class="modal-description">{{'NEW_TEXT.report_description_modal' | translate}}.</span>
            <div (click)="report(reportReason)" *ngFor="let reportReason of reportReasons" class="modal-report-item">
                <span>{{reportReason}}</span>
                <img src="../../../assets/icons/icon-arrow-left.svg" alt="">
            </div>
        </div>
    </div>
</div>
